
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 288 448","fill":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M80 192h128v-48c0-35.25-28.75-64-64-64s-64 28.75-64 64v48zm208 24v144c0 13.25-10.75 24-24 24H24c-13.25 0-24-10.75-24-24V216c0-13.25 10.75-24 24-24h8v-48C32 82.5 82.5 32 144 32s112 50.5 112 112v48h8c13.25 0 24 10.75 24 24z"}})])
          )
        }
      }
    